import { IUserGaDataLayerResponseSchema, TUser } from '../../types';
import { ISopr1User, ESopr1UserTypes } from '../../types/analytics/sopr1';

interface IGetUserParams {
  userData?: TUser;
  userGaData?: IUserGaDataLayerResponseSchema | null;
  abGroup: number;
}

export function getUser({ userData, userGaData, abGroup }: IGetUserParams): ISopr1User {
  const userTrackingData: ISopr1User = {
    abGroup,
    // type - обязательное поле, но апи может таймаутить и тогда оно будет пустым
    type: (userGaData ? userGaData.userType : '') as ESopr1UserTypes,
  };

  if (userData && userData.isAuthenticated) {
    userTrackingData.balance = userData.balance;
    userTrackingData.email = userData.email || '';
    userTrackingData.userId = userData.userId;
    userTrackingData.cianUserId = userData.id;
  }

  return userTrackingData;
}
